import { render, staticRenderFns } from "./FlagAnimation.vue?vue&type=template&id=c2da5d50"
import script from "./FlagAnimation.vue?vue&type=script&lang=js"
export * from "./FlagAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports